import * as React from "react";
import {TextAreaComponentProps} from "../../types/types";

export const TextAreaComponent = ( props: TextAreaComponentProps ) => {
    return <div className='form-group'>
        <label>{props.label}</label>
        <textarea className="form-control" value={props.currentValue} onChange={props.onChange}>
        </textarea>
    </div>;
};